import moment from 'moment'
import { v4 as uuid } from 'uuid'

const CommandeUtils = {
  flatProducts: (produits, idCommande, aux, commande_uuid) => produits.map((produit, index) => ({
    _id: produit._id,
    idCommande,
    idCode: produit.idCode || produit.code.idCode,
    commande_uuid,
    quantite: produit.quantite,
    idTempsLivraison: produit.idTempsLivraison,
    idConditionnementVente: produit.idConditionnementVente,
    idConditionnementCommande: produit.idConditionnementCommande || null,
    codesCommande: produit.codesCommande,
    idDenomination: produit.idDenomination || (produit.code ? produit.code.idDenomination : ''),
    auxiliaire: aux,
    commentaire: produit.commentaire || null,
    // Add 1 second on every products because we let the possibility to insert same product same qty (unique constraint)
    lastUpdate: moment().add(index, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
  })).filter(product => product.idCode),
  flatProductsSpecifique: (produits, idCommandeSpecifique) => produits.map(produit => ({
    idCommandeSpecifique,
    idCode: produit.idCode || produit.code.idCode,
    quantite: produit.quantite,
    idConditionnementVente: produit.idConditionnementVente,
    idDenomination: produit.idDenomination || produit.code.idDenomination,
  })).filter(product => product.idCode),
  flatPlateaux: (plateaux, idCommande, aux, commande_uuid) => plateaux.map(plateau => ({
    ...plateau, // TODO - Fin a way to load an exisitng ID ? Or re-implement DAO
    _id: plateau.idCommandePlateau || uuid(),
    idPlateau: plateau.idPlateau,
    idCommande,
    commande_uuid,
    prix: plateau.prix,
    montage: plateau.montage,
    quantite: plateau.quantite,
    lastUpdate: moment().format('YYYY-MM-DD HH:mm:ss'),
    auxiliaire: aux,
  })),
}
export default CommandeUtils
